import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'custom-input-file',
  templateUrl: './custom-input-file.component.html',
  styleUrls: ['./custom-input-file.component.css']
})
export class CustomInputFileComponent {
  @Input() parentForm: FormGroup = new FormGroup({});
  @Input() nameInput: string = 'nameInput';
  @Input() isSubmit: boolean = false;

  get nombreFormGroup(){
    return this.parentForm.get(this.nameInput);
  }

  value: File[] = [];
  gridList?: any = [];

  @Input() placeholder!: string;

  @Input() styleProperties: string = '';

  @Input() isMultiple : boolean = false;

  @Input()
  set ngValue(value: any){
    if(value != undefined){
      this.value= value;
    }

    this.ngValueChange.emit(this.value);
  }

  @Output()
  ngValueChange = new EventEmitter<any>();

  get ngValue() {
    return this.value;
  }

  onFileSelected(event: any): void {

    const selectedFiles: FileList = event.target.files;
    if (selectedFiles && selectedFiles.length > 0) {

      for (let i = 0; i < selectedFiles.length; i++) {

        const file: File = selectedFiles[i];

        const reader = new FileReader();

        if(!this.isMultiple){
          this.del(0);
        }

        reader.onload = () => {
          const base64Data: string | ArrayBuffer | null = reader.result;
          const binaryString: string | ArrayBuffer | null = reader.result;
          this.gridList.push({base: base64Data, name: file.name, size: (file.size / 1024), ext: file.type, binary: binaryString});
          this.value.push(file);
        };

        reader.readAsDataURL(file);
      }

    }
  }

  del(i: any){
    if(this.gridList.length > 0){
      this.gridList.splice(i, 1);
      this.value.splice(i, 1);
    }
  }
}
